import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { SEO } from "gatsby-theme-core";
import { Layout, HeaderOne, FooterOne } from "gatsby-theme-layout";
import {
    HeroSection03,
    VideoStreamingContainerThree,
} from "gatsby-theme-container";

const StreamingIndex = ({ data }) => (
    <Layout>
        <SEO pageName="Romantic Movie" />
        <HeaderOne data={{ ...data?.header, ...data.navigation }} />
        <HeroSection03
            data={{
                items: data?.romanticMovieSlider?.nodes,
            }}
        />
        <VideoStreamingContainerThree
            data={{
                items: data?.romanticMoviePost?.nodes,
            }}
        />
        <FooterOne data={{ ...data?.footer, ...data?.contact }} />
    </Layout>
);

export const query = graphql`
    query StreamingRomanticMovieQuery {
        header: general(section: { eq: "header-01" }) {
            ...Header01
        }
        navigation: general(section: { eq: "menu-streaming" }) {
            ...Menu01
        }
        footer: general(section: { eq: "footer-01" }) {
            ...Footer01
        }
        contact: general(section: { eq: "contact" }) {
            ...Contact01
        }
        page(title: { eq: "streaming-home-two" }) {
            content {
                ...PageContent
            }
        }
        romanticMovieSlider: allVideoStreamingMovie(
            sort: { fields: date, order: DESC }
            filter: {
                category: { elemMatch: { slug: { eq: "romantic" } } }
                is_featured: { eq: true }
            }
        ) {
            nodes {
                ...VideoStreamingMovie
            }
        }
        romanticMoviePost: allVideoStreamingMovie(
            sort: { fields: date, order: DESC }
            filter: { category: { elemMatch: { slug: { eq: "romantic" } } } }
        ) {
            nodes {
                ...VideoStreamingMovie
            }
        }
    }
`;

StreamingIndex.propTypes = {
    data: PropTypes.shape({
        header: PropTypes.shape({}),
        navigation: PropTypes.shape({}),
        footer: PropTypes.shape({}),
        contact: PropTypes.shape({}),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        romanticMovieSlider: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        romanticMoviePost: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};
export default StreamingIndex;
